import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'new-version-dialog',
  templateUrl: './new-version-dialog.component.html',
  styleUrls: ['./new-version-dialog.component.scss']
})
export class NewVersionDialogComponent {

  @Input() isDialogRefreshOpen: boolean = false;
  @Output() onCancel: EventEmitter<null> = new EventEmitter<null>();

  constructor(
    private swUpdate: SwUpdate
  ) { }

  onCloseDialog() {
    this.onCancel.emit();
  }

  // onConfirmRefresh() {
  //   location.reload();
  // }

  onConfirmRefresh(): void {
    // Reload the page to update to the latest version after the new version is activated
    this.swUpdate.activateUpdate()
      .then(() => document.location.reload())
      .catch(error => console.error('Failed to apply updates:', error));
  }
}
